/**
 * ErrorCard - Displays error responses from agents
 */
import { cn } from '@/lib/utils'
import { AlertCircle } from 'lucide-react'

export interface ErrorCardProps {
  error: string
  className?: string
}

export function ErrorCard({ error, className }: ErrorCardProps) {
  return (
    <div 
      role="alert" 
      className={cn(
        "flex items-start gap-2 p-3 rounded-lg bg-destructive/10 text-destructive border border-destructive/20",
        className
      )}
    >
      <AlertCircle className="h-5 w-5 mt-0.5 flex-shrink-0" />
      <span className="text-sm">{error}</span>
    </div>
  )
}
